"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoopTransport = void 0;

var _utils = require("@sentry/utils");

/** Noop transport */
var NoopTransport = exports.NoopTransport = function () {
  function NoopTransport() {}
  /**
   * @inheritDoc
   */


  NoopTransport.prototype.sendEvent = function (_) {
    return (0, _utils.resolvedSyncPromise)({
      reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
      status: 'skipped'
    });
  };
  /**
   * @inheritDoc
   */


  NoopTransport.prototype.close = function (_) {
    return (0, _utils.resolvedSyncPromise)(true);
  };

  return NoopTransport;
}();